import {
  GETCUSTOMEROWNERDETAILS_SUCCESS,
  GETCUSTOMEROWNERDETAILS_FAILED,
  RESET_GETCUSTOMEROWNERDETAILS,
  LOADING_GETCUSTOMEROWNERDETAILS,
  NETWORK_ERROR_GETCUSTOMEROWNERDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetCustomerOwnerDetails = () => {
  return { type: RESET_GETCUSTOMEROWNERDETAILS };
};

const getCustomerOwnerDetailsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETCUSTOMEROWNERDETAILS });
    await partnerServices
      .post("getCustomerOwnerDetails", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(getCustomerOwnerDetailsListsuccess(res.data));
            break;
          default:
            dispatch(getCustomerOwnerDetailsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETCUSTOMEROWNERDETAILS,
          payload: err,
        });
      });
  };
function getCustomerOwnerDetailsListsuccess(data) {
  return {
    type: GETCUSTOMEROWNERDETAILS_SUCCESS,
    payload: data,
  };
}
function getCustomerOwnerDetailsListFailed(data) {
  return {
    type: GETCUSTOMEROWNERDETAILS_FAILED,
    payload: data,
  };
}

export { resetGetCustomerOwnerDetails, getCustomerOwnerDetailsList };
